import { Env } from '../../../env';
import { ApiClient } from '../../../http/api_client';
import { InsertArraivalContactMailResponse } from '../../../models/currentsystem/soloare/insert_arraival_contact_mail_response';
import { ItemKey } from '../../../models/currentsystem/soloare/item_key';

export class ArrivalContactMailRegister {
    async insertArrivalContactMail(
        datetime: Date | null,
        param: ItemKey[]
    ): Promise<InsertArraivalContactMailResponse> {
        const paramjson = encodeURI(JSON.stringify(param)); // パラメータをJson化とエンコード

        // API戻り値が文字列の「{result:"0",errMessage:null}」のようにとなっている
        const result: string = await ApiClient.get(
            Env.SETTING.userPublicApi.urlBase +
            `buyer/view/a910/teeda.ajax?component=a910_arvlCntctMailAjaxPage&action=ajaxAddArvlCntctMail${(datetime !== null) ? '&time=' + datetime : ''}&param=${paramjson}`
        );

        const jsonResult = JSON.parse(result.replace('result', '"result"').replace('errMessage', '"errMessage"'));
        return new InsertArraivalContactMailResponse(jsonResult.result, jsonResult.errMessage);
    }
}
